import Cookies from 'js-cookie';
const SYNTHETIC_COOKIE_NAME = 'is-synthetic-account';
const AUTOMATION_COOKIE_NAME = 'is-automation-account';
const botRegexs = [
    'Googlebot\\/',
    'Googlebot-Mobile',
    'Googlebot-Image',
    'Googlebot-News',
    'Googlebot-Video',
    'AdsBot-Google([^-]|$)',
    'AdsBot-Google-Mobile',
    'Feedfetcher-Google',
    'Mediapartners-Google',
    'Mediapartners \\(Googlebot\\)',
    'APIs-Google'
];
const botRegex = new RegExp(botRegexs.join('|'));
/**
 * Logic that determines if we should skip identifying a user. The following types of users are skipped:
 *  - Automation Users
 *  - Synthetic Users
 *  - CVII Users
 *
 * @returns
 */
export function skipIdentify(traits) {
    if (isAutomationUser() || isSyntheticUser() || traits.isCVIIUser || isCrawlerBot()) {
        return true;
    }
    return false;
}
export function isAutomationUser() {
    return Boolean(Cookies.get(AUTOMATION_COOKIE_NAME));
}
export function isSyntheticUser() {
    return Boolean(Cookies.get(SYNTHETIC_COOKIE_NAME)) || globalThis._DATADOG_SYNTHETICS_BROWSER === true;
}
export function isCrawlerBot() {
    if (typeof navigator === 'undefined') {
        return false;
    }
    return !!(navigator && navigator.userAgent && botRegex.test(navigator.userAgent));
}
//# sourceMappingURL=skipIdentify.js.map